import { Box, Typography } from "@mui/material";

interface EmptyFieldStateProps {
  hasSelectedEntity: boolean;
  hasFields: boolean;
}

const EmptyFieldState = ({
  hasSelectedEntity,
  hasFields,
}: EmptyFieldStateProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        p: 4,
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {hasSelectedEntity && !hasFields
          ? "No fields available for the selected entity"
          : "Select an entity to show available fields to clean"}
      </Typography>
    </Box>
  );
};

export default EmptyFieldState;
